import React from "react";
import { Link } from "react-router-dom";
import { Construction, ArrowRight } from "lucide-react";

export default function ComingSoon({ title, description, eta, testid = "coming-soon" }) {
  return (
    <div className="max-w-3xl mx-auto py-16 text-center" data-testid={testid}>
      <div className="inline-flex items-center justify-center h-14 w-14 rounded-2xl bg-orange-600/10 border border-orange-600/20 mb-6">
        <Construction className="h-6 w-6 text-orange-500" strokeWidth={1.6} />
      </div>
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-500/80 mb-3">Coming Soon</p>
      <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-zinc-50 mb-3">{title}</h1>
      <p className="text-zinc-400 text-base max-w-xl mx-auto mb-2">{description}</p>
      {eta && <p className="text-zinc-500 text-sm">{eta}</p>}
      <Link
        to="/dashboard"
        className="inline-flex items-center gap-2 mt-8 px-4 py-2 rounded-lg bg-zinc-900 border border-zinc-800 text-zinc-200 hover:border-zinc-700 transition-colors"
        data-testid="coming-soon-return-btn"
      >
        Return to dashboard
        <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
